import * as constants from './constants';

const initialState = {};
const plansReferenceData = (state = initialState, action) => {
  switch (action.type) {
    case constants.UPDATE_PLANS_DATA: {
      return { ...state, ...action.response };
    }
    default:
      return state;
  }
};

export default plansReferenceData;
